const { ORDER_STATUS, ORDER_TYPE, ORDER_PAYMENT_STATUS, ORDER_LOG_TYPE, DELIVERY_TYPE } = require('./order');
const { PAYMENT_TYPE } = require('./payment');
const { DEVICES } = require('./devices');

const defaultStatuses = {
    submited: '',
    paid: '',
    accepted: '',
    awaiting: '',
    delivery: '',
    done: '',
    canceled: '',
    incedent: '',
    prepared: '',
    in_work: '',
    awaiting_ready: '',
    delivery_concierge: '',
    meeting_point: '',
    payment_correction: '',
};

module.exports = {
    orderStatusTitle(orderStatusId, orderType, paymentType, statuses = defaultStatuses, deliveryType, deliveredDoor) {
        switch (orderStatusId) {
            case ORDER_STATUS.SUBMITTED: return statuses?.submited ? statuses?.submited : (paymentType === PAYMENT_TYPE.PRE_PAYMENT ? 'Оформление' : 'Подтверждение');
            case ORDER_STATUS.IN_WORK: return statuses?.in_work ? statuses?.in_work : 'В работе'
            case ORDER_STATUS.PREPARED: return statuses?.prepared ? statuses?.prepared : 'Оплата';
            case ORDER_STATUS.PAID: return statuses?.paid ? statuses?.paid : 'Оплачен';
            case ORDER_STATUS.ACCEPTED: return statuses?.accepted ? statuses?.accepted : 'Принят партнером';
            case ORDER_STATUS.DECLINED: return statuses?.declined ? statuses?.declined : 'Отклонен партнером';
            case ORDER_STATUS.AWAITING:
                if (orderType === ORDER_TYPE.RESTAURANT_DELIVERY) return 'Готовим';
                return statuses?.awaiting ? statuses?.awaiting : 'Собираем';
            case ORDER_STATUS.AWAITING_READY: return statuses?.awaiting_ready ? statuses?.awaiting_ready : 'Заказ готов';
            case ORDER_STATUS.DELIVERY: return statuses?.delivery ? statuses?.delivery : 'Курьер';
            case ORDER_STATUS.DELIVERY_CONCIERGE: return statuses?.delivery_concierge ? statuses?.delivery_concierge : 'Консьерж';
            case ORDER_STATUS.MEETING_POINT: return statuses?.meeting_point ? statuses?.meeting_point : 'В точке встречи';
            case ORDER_STATUS.PAYMENT_CORRECTION: return statuses?.payment_correction ? statuses?.payment_correction : 'Корректировка';
            case ORDER_STATUS.DONE:
                if (statuses?.done) {
                    return deliveredDoor ? `${statuses?.done} (доставлен до двери)` : statuses?.done ;
                }
                return deliveredDoor ? 'Выполнен (доставлен до двери)' : 'Выполнен';
            case ORDER_STATUS.CANCELED: return statuses?.canceled ? statuses?.canceled : 'Отменен';
            case 25 : return 'Доставлен до двери';
        }
        return '???';
    },
    orderStatusStyle(orderStatusId, orderType, paymentType) {
        const style = {
            whiteSpace: 'nowrap',
            color: '#FFFFFF'
        };
        switch (orderStatusId) {
            case ORDER_STATUS.SUBMITTED:
                if(paymentType === PAYMENT_TYPE.PRE_PAYMENT) {
                    style.backgroundColor = '#D6D3AD';
                }
                else {
                    style.backgroundColor = '#EF584A';
                }
                break;
            case ORDER_STATUS.IN_WORK:
                style.backgroundColor = '#498AEE';
                break;
            case ORDER_STATUS.PREPARED:
                style.backgroundColor = '#E4CD75';
                break;
            case ORDER_STATUS.PAID:
                style.backgroundColor = '#E26B64';
                break;
            case ORDER_STATUS.ACCEPTED:
                style.backgroundColor = '#E26B64';
                break;
            case ORDER_STATUS.DECLINED:
                style.backgroundColor = '#E26B64';
                break;
            case ORDER_STATUS.AWAITING:
                style.backgroundColor = '#F6BB36';
                break;
            case ORDER_STATUS.AWAITING_READY:
                style.backgroundColor = '#F95D07';
                break;
            case ORDER_STATUS.DELIVERY:
                style.backgroundColor = '#48A7C5';
                break;
            case ORDER_STATUS.DELIVERY_CONCIERGE:
                style.backgroundColor = '#6DCFD5';
                break;
            case ORDER_STATUS.MEETING_POINT:
                style.backgroundColor = '#58ADA0'
                break;
            case ORDER_STATUS.PAYMENT_CORRECTION:
                style.backgroundColor = '#E26B64';
                break;
            case ORDER_STATUS.DELIVERED_DOOR:
            case ORDER_STATUS.DONE:
                style.backgroundColor = '#97CE98';
                break;
            case ORDER_STATUS.CANCELED:
                style.backgroundColor = '#A8A8A8';
                break;
        }
        return style;
    },
    orderTypeTitle(orderTypeId) {
        switch (orderTypeId) {
            case ORDER_TYPE.RESTAURANT_DELIVERY: return 'Реcтораны';
            case ORDER_TYPE.FLOWERS_DELIVERY: return 'Цветы';
            case ORDER_TYPE.GROCER_DELIVERY: return 'Магазины';
            case ORDER_TYPE.PHARMACY_DELIVERY: return 'Аптеки';
            case ORDER_TYPE.ASSISTANT_HELP: return 'Помощник';
            case ORDER_TYPE.ENTITY_DELIVERY: return 'Сервис';
        }
        return '???';
    },
    paymentStatusTitle(status) {
        switch (status) {
            case ORDER_PAYMENT_STATUS.PROCESSING: return 'Обработка...';
            case ORDER_PAYMENT_STATUS.SUCCESS: return 'Успех';
            case ORDER_PAYMENT_STATUS.FAIL: return 'Отказ';
            case ORDER_PAYMENT_STATUS.CANCELLED: return 'Отменен';
            case ORDER_PAYMENT_STATUS.NOT_FOUND: return 'Не найден';
        }
        return '???';
    },
    paymentStatusBagde(status) {
        switch (status) {
            case ORDER_PAYMENT_STATUS.PROCESSING: return 'secondary';
            case ORDER_PAYMENT_STATUS.SUCCESS: return 'success';
            case ORDER_PAYMENT_STATUS.FAIL: return 'danger';
            case ORDER_PAYMENT_STATUS.CANCELLED: return 'secondary';
            case ORDER_PAYMENT_STATUS.NOT_FOUND: return 'secondary';
        }
        return '???';
    },
    orderLogTypeTitle(type) {
        switch (type) {
            case ORDER_LOG_TYPE.CREATED: return 'Создание';
            case ORDER_LOG_TYPE.STATUS_UPDATED: return 'Изменение статуса';
            case ORDER_LOG_TYPE.UPDATED: return 'Изменение';
        }
        return '???';
    },
    orderLogTypeBagde(type) {
        switch (type) {
            case ORDER_LOG_TYPE.CREATED: return 'success';
            case ORDER_LOG_TYPE.STATUS_UPDATED: return 'primary';
            case ORDER_LOG_TYPE.UPDATED: return 'secondary';
        }
        return '???';
    },
    orderPlatformFormat(deviceInfo) {
        const { browser, os, osVersion, appVersion } = deviceInfo;
        let device = '';
        if(browser) {
            device += 'Browser ';
        }
        if (os) {
            device += DEVICES[os];
        }
        if (osVersion) {
            device += ` - ${osVersion}`;
        }
        device += `, ${appVersion}`;
        return device;
    }
}
